import React from 'react'
import { Button, Card } from '..'

const NavCard = function ({ icon, title, description, buttonText, action }) {
  return (
    <Card className="nav-card">
      <span className="">
        {icon}
      </span>
      <span className="nav-title">{title}</span>
      <span className="nav-description">{description}</span>
      <span className="spacer"></span>
      <Button role="button" className="nav-button" onClick={action}>{buttonText}</Button>
    </Card>
  )
}

export default NavCard